import { StyleSheet, Text, View } from 'react-native'
import React from 'react'
import { fontFamily } from '../../../../../../theme'

type AvatarProps = {
  color: string
  initials: string
}

const Avatar = ({ color, initials }: AvatarProps) => {
  return (
    <View style={[styles.container, { backgroundColor: color }]}>
      <Text style={styles.text}>{initials}</Text>
    </View>
  )
}

export default Avatar

const styles = StyleSheet.create({
  container: {
    height: 32,
    width: 32,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 16
  },
  text: {
    fontSize: 12,
    fontFamily: fontFamily.GTAmericaExtended
  }
})
